import React, { useState, useEffect } from "react";



import { Box, Typography, Divider, List, ListItem, ListItemIcon, ListItemText, CardMedia, Paper } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppsIcon from "@mui/icons-material/Apps";


const GOQiiAppHomeScreen = () => {


  // Handle browser navigation
  // Replace the existing useEffect with this:
useEffect(() => {
  const handleBackButton = (e) => {
    // Prevent default navigation
    e.preventDefault();
    // Navigate directly to launch URL
    // window.location.replace(launchUrl);
  };

  // Add the back button listener
  window.addEventListener('popstate', handleBackButton);

  // Set initial history state without causing navigation
  window.history.replaceState({ page: 'home' }, '', window.location.pathname);

  return () => {
    window.removeEventListener('popstate', handleBackButton);
  };
}, []);
  

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        minHeight: "100vh",
        // backgroundColor: "#f4f6f8",
        overflow: "hidden",
        backgroundImage: "url(https://appcdn.goqii.com/storeimg/82809_1733314164.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
    
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 3,
          backgroundColor: "rgba(240, 240, 240, 0.6)",
          backdropFilter: "blur(4px)",
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "375px", // Mobile width
            height: "667px", // Mobile height
            backgroundColor: "#fff",
            borderRadius: "24px",
            overflow: "hidden",
            position: "relative",
            border: "2px solid #ccc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Status Bar */}
          {/* <Box
            sx={{
              width: "100%",
              height: "24px",
              backgroundColor: "#000",
              color: "#fff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0 8px",
              fontSize: "12px",
            }}
          > */}
            {/* add system time with realtime time running in am/pm format */}
            {/* <span>{new Date().toLocaleTimeString(undefined, { timeStyle: "short" })}</span>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <span>📶</span>
              <span style={{ marginLeft: "4px" }}>🔋</span>
            </Box>
          </Box> */}

          {/* Main Content Area */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
          
              <iframe
                src={"https://nir.goqii.com/?screen=homescreen&encUserId=ekc3QmpBZUZTREJieGZyMDl2Yk9rdz09&jwtToken=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMDAwMDAyNjg0NjU5OmMzTmpUMVJPTjJVelJ6STVkVlZTT1VKQlNEaEdkejA5OmVkZ2UiLCJpYXQiOjE3MzQ5Mzc5NzQsImV4cCI6MTc2NDkzNzk3NH0.RxJgl0FTLzRhjdO4SWa3eGSTyAzJ1oY8UkJvgwuu4DA"}
                title="GOQii Content"
                style={{
                  width: "100%",  // ✅ No extra width
                  height: "100%", // ✅ No extra height
                  border: "none",
                  zoom: "0.8", // ✅ Scales content without changing height
                  display: "block",
                }}
              />
             
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};
export default GOQiiAppHomeScreen;